/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmailClose = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h20v11h-2V5.227l-8 7.111-8-7.111V18h9v2H2zm3.63 2L12 9.662 18.37 4z" />
        <path d="m17.243 18.657-2.122-2.121 1.414-1.415 2.122 2.122 2.121-2.122 1.414 1.414-2.121 2.122 2.121 2.121-1.414 1.414-2.121-2.12-2.121 2.12-1.415-1.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgEmailClose as EmailClose };
